import { css, html } from 'react-strict-dom';

import { Style } from '../../constants';
import { color } from '../../constants/color.css';
import Skeleton from '../Skeleton';
import Stack from '../Stack';

const ROWS = 7;

/** Skeleton for the client landing screen (`TicketsPage`). */
export default function TicketsListSkeleton() {
  return (
    <Stack padH={1.5} padV={1.5} gap={1.5}>
      <Skeleton width={180} height={20} />

      <html.div style={[Style.row, Style.alignCenter, styles.tabs]}>
        <Skeleton width={64} height={12} />
        <Skeleton width={64} height={12} />
      </html.div>

      <html.div
        style={[
          Style.row,
          Style.alignCenter,
          Style.spaceBetween,
          Style.wrap,
          styles.toolbar,
        ]}
      >
        <Skeleton width={240} height={36} radius={8} />
        <html.div style={[Style.row, Style.alignCenter, styles.toolbarRight]}>
          <Skeleton width={40} height={36} radius={8} />
          <Skeleton width={40} height={36} radius={8} />
          <Skeleton width={110} height={36} radius={100} />
        </html.div>
      </html.div>

      <html.div style={styles.card}>
        <html.div style={[Style.row, Style.alignCenter, styles.cardHeader]}>
          <Skeleton width={120} height={12} />
          <Skeleton width={80} height={12} />
        </html.div>
        {Array.from({ length: ROWS }, (_, index) => (
          <html.div
            key={index}
            style={[
              Style.row,
              Style.alignCenter,
              styles.row,
              index > 0 && styles.rowDivider,
            ]}
          >
            <Skeleton width={32} height={32} circle />
            <html.div style={styles.rowText}>
              <Skeleton width="60%" height={12} />
              <Skeleton width="40%" height={12} />
            </html.div>
            <Skeleton width={64} height={20} radius={100} />
            <Skeleton width={80} height={12} />
          </html.div>
        ))}
      </html.div>

      <html.div style={[Style.row, Style.centerBoth]}>
        <Skeleton width={180} height={12} />
      </html.div>
    </Stack>
  );
}

const styles = css.create({
  tabs: {
    gap: 24,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: color.neutral20,
    paddingBottom: 12,
  },
  toolbar: {
    gap: 8,
  },
  toolbarRight: {
    gap: 8,
  },
  card: {
    backgroundColor: color.neutral0,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: color.neutral20,
    borderRadius: 12,
    overflow: 'hidden',
  },
  cardHeader: {
    gap: 16,
    paddingBlock: 16,
    paddingInline: 16,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: color.neutral20,
  },
  row: {
    gap: 16,
    paddingBlock: 16,
    paddingInline: 16,
  },
  rowDivider: {
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: color.neutral10,
  },
  rowText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    flex: 1,
    minWidth: 0,
  },
});
